<template>
  <div class="main">
    <b-row>
      <b-col xs="6" sm="6" md="6" lg="6" xl="6">
        <span class="title">
          <i class="toggle-icon" :class="classIcon"></i> {{ title }}
        </span>
        <br />
      </b-col>
      <b-col xs="6" sm="6" md="6" lg="4" xl="4">
        <VueToggles height="23" width="60" checkedText="Sim" uncheckedText="Não" :checkedBg="color"
          uncheckedBg="lightgrey" :disabled="disabled" :value="value" @click="clicked" />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import VueToggles from "vue-toggles";

export default {
  name: "Toggle",
  components: {
    VueToggles,
  },
  props: {
    title: String,
    color: String,
    classIcon: String,
    disabled: {
      type: Boolean,
      default: false,
    },
    params: Object,
    changed: Function,
    value: Boolean,
  },
  data() {
    return {
      valueLocal: false,
    };
  },
  created() {
    this.valueLocal = this.value;
  },
  methods: {
    clicked() {
      this.valueLocal = !this.valueLocal;
      this.$emit("input", this.valueLocal);
      if (this.changed) this.changed(this.params);
    },
  },
};
</script>

<style scoped>
.main {
  padding: 5px;
}

.toggle-icon {
  font-size: 14px;
  margin-right: 5px;
  margin-bottom: 2px;
}

.title {
  margin-left: -3px;
  padding-right: 35px;
  margin-bottom: 50px !important;
}
</style>
